<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-dialog v-model="show_header_preview">
        <view-header v-model="content.header"></view-header>
      </v-dialog>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card class="admin_secondary">
            <v-card-title class="secondary white--text">
              General Settings
              <v-spacer></v-spacer>
              <v-btn
                v-if="modified && !loading"
                color="green"
                fab
                small
                dark
                class="mr-2"
                @click="save"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>

            <v-container class>
              <v-row>
                <v-col cols="12" xl="6">
                  <v-card>
                    <v-card-title class="secondary white--text">
                      Header
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-container>
                      <v-row align="center">
                        <v-col cols="6" class="text-right">
                          <v-switch
                            color="success"
                            label="Visible"
                            v-model="content.header.visible"
                          ></v-switch>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <v-btn
                            color="primary"
                            text
                            @click="show_header_preview = true"
                            >Preview</v-btn
                          >
                        </v-col>
                      </v-row>
                      <draggable v-model="content.header.tiles">
                        <v-row
                          align="center"
                          v-for="(tile, t) in content.header.tiles"
                          :key="t"
                        >
                          <v-col cols="6">
                            <v-text-field
                              outlined
                              hide-details
                              label="Title"
                              v-model="tile.title"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox
                              v-model="tile.sidebars"
                              label="Desktop Sidebars"
                              color="primary"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2" class="text-right">
                            <v-btn icon class="handle">
                              <v-icon>fa fa-align-justify</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteHeaderTile(tile)">
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="3">
                            <h5>Logo</h5>
                            <image-picker v-model="tile.logo"></image-picker>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              outlined
                              :rows="5"
                              hide-details
                              label="Description"
                              v-model="tile.description"
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              hide-details
                              label="Link text"
                              v-model="tile.link.text"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              hide-details
                              label="Link url"
                              v-model="tile.link.url"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            v-if="t < content.header.tiles.length - 1"
                          >
                            <v-divider class="my-4"></v-divider>
                          </v-col>
                        </v-row>
                      </draggable>
                      <v-row>
                        <v-col cols="12" class="text-center">
                          <v-btn
                            dark
                            fab
                            color="primary"
                            @click="addHeaderTile()"
                          >
                            <v-icon>fa-plus</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Info Box</v-card-title
                    >
                    <v-container>
                      <v-row align="center">
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            label="Title"
                            v-model="content.info_box.title"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            outlined
                            :rows="5"
                            hide-details
                            label="Description"
                            v-model="content.info_box.description"
                          ></v-textarea>
                        </v-col>

                        <v-col cols="3">
                          <h5>Logo</h5>
                          <image-picker
                            v-model="content.info_box.logo"
                          ></image-picker>
                        </v-col>
                        <v-col cols="9"></v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            outlined
                            hide-details
                            label="Link text"
                            v-model="content.info_box.link.text"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            outlined
                            hide-details
                            label="Link url"
                            v-model="content.info_box.link.url"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Support Options</v-card-title
                    >
                    <v-container>
                      <v-row align="start">
                        <v-col cols="8" lg="3">
                          <v-text-field
                            label
                            outliend
                            prepend-inner-icon="fa-dollar-sign"
                            hide-details
                            dense
                            v-model="add_support"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" lg="2">
                          <v-btn
                            fab
                            color="primary"
                            dark
                            small
                            @click="addSupport"
                          >
                            <v-icon>fa-plus</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" lg="7">
                          <draggable v-model="content.support_options">
                            <v-chip
                              close
                              class="ma-2"
                              color="green"
                              dark
                              v-for="(support, s) in content.support_options"
                              :key="s"
                              @click:close="
                                content.support_options.splice(
                                  content.support_options.indexOf(support),
                                  1
                                )
                              "
                              >${{ support }}</v-chip
                            >
                          </draggable>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Support Description</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.support_description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Thank You Video</v-card-title
                    >

                    <v-container>
                      <v-row align="center">
                        <v-col cols="12">
                          <v-text-field
                            v-model="content.support_thanks_video.url"
                            label="Url"
                            hide-details
                            outlined
                            append-outer-icon="fa fa-play"
                            @click:append-outer="
                              $eventBus.$emit(
                                'play_video',
                                content.support_thanks_video.url
                              )
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          :cols="
                            content.support_thanks_video.thumbnail ? 8 : 12
                          "
                        >
                          <v-text-field
                            v-model="content.support_thanks_video.thumbnail"
                            label="Thumbnail"
                            hide-details
                            outlined
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="4"
                          v-if="content.support_thanks_video.thumbnail"
                        >
                          <v-img
                            :src="content.support_thanks_video.thumbnail"
                          ></v-img>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Stripe Public Key</v-card-title
                    >
                    <v-container>
                      <v-text-field
                        v-model="content.stripe_key"
                        hide-details
                        outlined
                      ></v-text-field>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Profile Video Edit Claim Description</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.edit_claim_description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Project Requirements</v-card-title
                    >
                    <v-container>
                      <h4>Thank You Video</h4>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Title"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.video_required.title
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            label="Description"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.video_required
                                .description
                            "
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <h4>Thank You Video In Review</h4>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Title"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.video_review.title
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            label="Description"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.video_review
                                .description
                            "
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <h4>Rank not high enough</h4>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Title"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.rank_required.title
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            label="Description"
                            outlined
                            hide-details
                            v-model="
                              content.project_requirements.rank_required
                                .description
                            "
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Project Agreements</v-card-title
                    >
                    <v-container>
                      <h4>Non-Contest</h4>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.project[0]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.project[1]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.project[2]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.project[3]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <h4>Contest</h4>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.contest[0]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.contest[1]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.contest[2]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            outlined
                            hide-details
                            v-model="content.project_agreements.contest[3]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-actions class="secondary white--text">
                      <v-col cols="12">
                        <h3>Link Whitelist</h3>
                      </v-col>
                    </v-card-actions>
                    <v-list class="py-0">
                      <v-list-item class="secondary lighten-1">
                        <v-list-item-content>
                          <v-text-field
                            dark
                            hide-details
                            clearable
                            outlined
                            label="Add Link"
                            v-model="new_link"
                            @keyup.enter="addLink"
                          ></v-text-field>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            fab
                            dark
                            color="primary"
                            small
                            @click="addLink"
                          >
                            <v-icon small>fa-plus</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>

                      <v-divider v-if="content.links_whitelist"></v-divider>
                      <div class style="max-height: 340px; overflow-y: auto">
                        <draggable v-model="content.links_whitelist">
                          <v-list-item
                            v-for="(link, i) in content.links_whitelist"
                            :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon :color="$helpers.linkColor(link)" large>{{
                                $helpers.linkIcon(link)
                              }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <a
                                class="nolink caption"
                                :href="link"
                                target="_blank"
                              >
                                <span class>{{ link }}</span>
                              </a>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn
                                icon
                                small
                                @click="
                                  content.links_whitelist.splice(
                                    content.links_whitelist.indexOf(link),
                                    1
                                  )
                                "
                              >
                                <v-icon small>fa-times</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </draggable>
                      </div>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" xl="6">
                  <v-card>
                    <v-card-title class="secondary white--text"
                      >Login Description</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.login_description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Register Description</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.register_description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Business Register Description</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.business_register_description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Newsletter</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        v-model="content.newsletter"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title
                      :style="
                        gradientStyle(
                          content.footer_banner.color_1,
                          content.footer_banner.color_2
                        )
                      "
                      class="white--text"
                      >Footer Banner</v-card-title
                    >
                    <v-container>
                      <v-row align="center">
                        <v-col cols="12">
                          <v-text-field
                            label="Title"
                            v-model="content.footer_banner.title"
                            hide-details
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            label="Text"
                            v-model="content.footer_banner.text"
                            hide-details
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            label="Link"
                            v-model="content.footer_banner.link"
                            hide-details
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-center">
                          <h5>Logo</h5>
                          <image-picker
                            v-model="content.footer_banner.logo"
                          ></image-picker>
                        </v-col>
                        <v-col cols="12">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                :color="content.footer_banner.color_1"
                                dark
                                v-on="on"
                                >Color 1</v-btn
                              >
                            </template>
                            <v-color-picker
                              v-model="content.footer_banner.color_1"
                              show-swatches
                              :hide-mode-switch="true"
                              mode="hex"
                            ></v-color-picker>
                          </v-menu>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="ml-4"
                                :color="content.footer_banner.color_2"
                                dark
                                v-on="on"
                                >Color 2</v-btn
                              >
                            </template>
                            <v-color-picker
                              v-model="content.footer_banner.color_2"
                              show-swatches
                              :hide-mode-switch="true"
                              mode="hex"
                            ></v-color-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Footer</v-card-title
                    >
                    <v-container>
                      <v-textarea
                        :rows="10"
                        v-model="content.footer.description"
                        label="Description"
                        hide-details
                        outlined
                      ></v-textarea>
                    </v-container>

                    <v-list-item class="secondary lighten-1">
                      <v-list-item-content>
                        <v-text-field
                          dark
                          hide-details
                          clearable
                          outlined
                          label="Social links"
                          v-model="add_footer_link"
                          @keyup.enter="addFooterLink"
                        ></v-text-field>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          fab
                          dark
                          color="primary"
                          small
                          @click="addFooterLink"
                        >
                          <v-icon small>fa-plus</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>

                    <v-container>
                      <v-row>
                        <v-col cols="12" class="text-center">
                          <draggable v-model="content.footer.social_links">
                            <v-chip
                              close
                              class="ma-2"
                              :color="$helpers.linkColor(link)"
                              dark
                              v-for="(link, l) in content.footer.social_links"
                              :key="l"
                              @click:close="
                                content.footer.social_links.splice(
                                  content.footer.social_links.indexOf(link),
                                  1
                                )
                              "
                            >
                              <v-icon class="mr-4">{{
                                $helpers.linkIcon(link)
                              }}</v-icon>
                              <a
                                :href="link"
                                target="_blank"
                                class="nolink white--text"
                                >{{ link }}</a
                              >
                            </v-chip>
                          </draggable>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Terms</v-card-title
                    >
                    <v-container style="height: 530px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.terms"
                            style="height: 400px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Business Terms</v-card-title
                    >
                    <v-container style="height: 530px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.terms_business"
                            style="height: 400px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Privacy</v-card-title
                    >
                    <v-container style="height: 530px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.privacy"
                            style="height: 400px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Cookies Policy</v-card-title
                    >
                    <v-container style="height: 530px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.cookies_policy"
                            style="height: 400px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Affiliate Disclaimer</v-card-title
                    >
                    <v-container style="height: 530px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.affiliate_disclaimer"
                            style="height: 400px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text"
                      >Affiliate Notification</v-card-title
                    >
                    <v-container style="height: 330px">
                      <v-row>
                        <v-col cols="12">
                          <vue-editor
                            v-model="content.affiliate_notification"
                            style="height: 200px"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="grey lighten-3" v-if="modified">
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                dark
                id="save-btn"
                @click="save"
                :loading="loading"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import imagePicker from "@/components/app/image-picker-2";
import viewHeader from "@/components/app/header";
import draggable from "vuedraggable";

export default {
  name: "",
  components: {
    imagePicker,
    viewHeader,
    draggable,
  },
  data: () => ({
    show_header_preview: false,
    add_support: null,
    add_footer_link: null,
    new_link: null,
    content: {
      footer: {},
      footer_banner: {},
      terms: "",
      terms_business: "",
      login_description: "",
      register_description: "",
      support_description: "",
      support_thanks_video: "",
      edit_claim_description: "",
      stripe_key: "",
      support_options: {},
      links_whitelist: [],
      project_agreements: [],
      header: {},
      affiliate_disclaimer: "",
      cookies_policy: "",
      affiliate_notification: "",
    },
    loading: false,
    modified: false,
  }),
  watch: {
    content: {
      handler: function () {
        this.modified = true;
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    this.load();
  },
  methods: {
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2});`;
    },
    addHeaderTile() {
      this.content.header.tiles.push({
        title: "",
        description: "",
        link: {
          url: "",
          text: "",
        },
      });
    },
    deleteHeaderTile(tile) {
      if (!confirm("Delete header section ?")) {
        return;
      }
      this.content.header.tiles.splice(
        this.content.header.tiles.indexOf(tile),
        1
      );
    },
    addLink() {
      if (!this.new_link) {
        return;
      }
      this.content.links_whitelist.push(this.new_link);
      this.new_link = null;
    },
    addFooterLink() {
      if (!this.add_footer_link) {
        return;
      }
      this.content.footer.social_links.push(this.add_footer_link);
      this.add_footer_link = null;
    },
    addSupport() {
      if (!this.add_support) {
        return;
      }
      this.content.support_options.push(parseInt(this.add_support));
      this.add_support = null;
    },
    async load() {
      this.loading = true;
      let application = await this.$api(`/application`);
      this.content = {
        footer: application.footer,
        footer_banner: application.footer_banner,
        terms: application.terms,
        login_description: application.login_description,
        register_description: application.register_description,
        support_description: application.support_description,
        business_register_description:
          application.business_register_description,
        support_thanks_video: application.support_thanks_video,
        edit_claim_description: application.edit_claim_description,
        stripe_key: application.stripe_key,
        support_options: application.support_options,
        links_whitelist: application.links_whitelist,
        project_agreements: application.project_agreements,
        terms_business: application.terms_business,
        privacy: application.privacy,
        newsletter: application.newsletter,
        project_requirements: application.project_requirements,
        header: application.header,
        info_box: application.info_box,
        affiliate_disclaimer: application.affiliate_disclaimer,
        cookies_policy: application.cookies_policy,
        affiliate_notification: application.affiliate_notification,
      };
      setTimeout(
        function () {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
    },
    async save() {
      this.loading = true;
      await this.$api({
        method: "POST",
        url: `/account/admin/application`,
        data: {
          footer: this.content.footer,
          footer_banner: this.content.footer_banner,
          terms: this.content.terms,
          login_description: this.content.login_description,
          register_description: this.content.register_description,
          support_description: this.content.support_description,
          business_register_description: this.content
            .business_register_description,
          support_thanks_video: this.content.support_thanks_video,
          edit_claim_description: this.content.edit_claim_description,
          stripe_key: this.content.stripe_key,
          support_options: this.content.support_options,
          links_whitelist: this.content.links_whitelist,
          project_agreements: this.content.project_agreements,
          terms_business: this.content.terms_business,
          privacy: this.content.privacy,
          newsletter: this.content.newsletter,
          project_requirements: this.content.project_requirements,
          header: this.content.header,
          info_box: this.content.info_box,
          affiliate_disclaimer: this.content.affiliate_disclaimer,
          cookies_policy: this.content.cookies_policy,
          affiliate_notification: this.content.affiliate_notification,
        },
      });
      setTimeout(
        function () {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
      this.$store.dispatch("app/load");
    },
    scrollToSave() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#save-btn", {
            duration: 300,
            offset: 100,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        this.scrollToSave();
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
